import React, {FC, useState, useRef, useEffect} from "react";

import {Table, Space, Modal, Dropdown, Menu, message, Layout, Form, Row, Col, Input, Button, Divider, Spin, FormInstance, Alert} from 'antd';

import {DownOutlined, RedoOutlined, UpOutlined} from '@ant-design/icons';

import {Pageable, Pagination} from './../../../../utils/data/Type';
import TableUtils from './../../../../utils/ui/table/TableUtils';
import { OutsideElevatorLog, OutsideElevatorLogQto } from './../../type/OutsideElevatorLogType';
import OutsideElevatorLogApi from "../../api/OutsideElevatorLogApi";
import OutsideElevatorLogAddForm from "./OutsideElevatorLogAddForm";
import OutsideElevatorLogDetail from "./OutsideElevatorLogDetail";
import { ColumnsType, ColumnType } from "antd/lib/table";
import TableSizeSetting from "../../../../components/antx/table/TableSizeSetting";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import TableColumnSetting from "../../../../components/antx/table/TableColumnSetting";
import ProForm, { ProFormInstance, ProFormText } from "@ant-design/pro-form";

const getTableScrollY = (size:SizeType, pagination:any, tableHeight:number)=>{

    let scrollY = tableHeight;

    switch(size){
        case 'small':
            scrollY = scrollY-39;
            if(pagination){
                scrollY = scrollY-56;
            }
            return scrollY;
        case 'middle':
            scrollY = scrollY-47;
            if(pagination){
                scrollY = scrollY-56;
            }
            return scrollY;
        default:
            scrollY = scrollY-55;
            if(pagination){
                scrollY = scrollY-64;
            }
            return scrollY;
    }
}

const OutsideElevatorLogPage:React.FC = ()=>{
    const container = useRef<HTMLDivElement>(null);
    const queryFormRef = useRef<ProFormInstance<OutsideElevatorLogQto>>(null);

    const [addFormVisible, setAddFormVisible] = useState<boolean>(false); //新建表单可见状态
    const [detailVisible, setDetailVisible] = useState<boolean>(false); //明细可见状态
    const [queryFormExpand, setQueryFormExpand] = useState<boolean>(false); //查询表单展开状态
    const [currentOutsideElevatorLog, setCurrentOutsideElevatorLog] = useState<OutsideElevatorLog>({}); //当前记录
    const [tableSize, setTableSize] = useState<SizeType>('middle'); //表格尺寸
    const [columns, setColumns] = useState<ColumnsType<OutsideElevatorLog>>([]); //表格列
    const [tableHeight, setTableHeight] = useState<number>(0); //表格高度
    const [queryParams, setQueryParams] = useState<any>({}); //查询参数
    const [pageData, setPageData] = useState<Pagination>(); //分页查询服务端返回数据
    const [spinning, setSpinning] = useState<boolean>(false); //加载状态
    const [selectedRows, setSelectedRows] = useState<OutsideElevatorLog[]>([]);

    const defaultColumns:ColumnsType<OutsideElevatorLog> = [
        {
            key: "rowNo",
            title: "序号",
            dataIndex: "rowNo",
            width: 70,
            fixed: 'left',
        },
        {
            key: "outKey",
            title: "外部记录ID",
            dataIndex: "outKey",
            width: 100,
            ellipsis: true,
        },
        {
            key: "deviceSn",
            title: "设备序列号",
            dataIndex: "deviceSn",
            width: 100,
            ellipsis: true,
        },
        {
            key: "deviceTime",
            title: "设备时间",
            dataIndex: "deviceTime",
            width: 100,
            ellipsis: true,
        },
        {
            key: "load",
            title: "载重",
            dataIndex: "load",
            width: 100,
            ellipsis: true,
        },
        {
            key: "loadPercent",
            title: "载重百分比",
            dataIndex: "loadPercent",
            width: 100,
            ellipsis: true,
        },
        {
            key: "peopleCount",
            title: "人数",
            dataIndex: "peopleCount",
            width: 100,
            ellipsis: true,
        },
        {
            key: "windSpeed",
            title: "风速",
            dataIndex: "windSpeed",
            width: 100,
            ellipsis: true,
        },
        {
            key: "height",
            title: "高度",
            dataIndex: "height",
            width: 100,
            ellipsis: true,
        },
        {
            key: "speed",
            title: "升降机运行速度",
            dataIndex: "speed",
            width: 100,
            ellipsis: true,
        },
        {
            key: "totalMileage",
            title: "升降机运行里程",
            dataIndex: "totalMileage",
            width: 100,
            ellipsis: true,
        },
        {
            key: "slantAngel",
            title: "倾斜角度",
            dataIndex: "slantAngel",
            width: 100,
            ellipsis: true,
        },
        {
            key: "callFloor",
            title: "呼叫楼层",
            dataIndex: "callFloor",
            width: 100,
            ellipsis: true,
        },
        {
            key: "currentFloor",
            title: "当前楼层",
            dataIndex: "currentFloor",
            width: 100,
            ellipsis: true,
        },
        {
            key: "limitSwitch",
            title: "限位开关",
            dataIndex: "limitSwitch",
            width: 100,
            ellipsis: true,
        },
        {
            key: "runningState",
            title: "限位开关",
            dataIndex: "runningState",
            width: 100,
            ellipsis: true,
        },
        {
            key: "bypass",
            title: "Bypass开关",
            dataIndex: "bypass",
            width: 100,
            ellipsis: true,
        },
        {
            key: "totalRunDays",
            title: "总运行天数",
            dataIndex: "totalRunDays",
            width: 100,
            ellipsis: true,
        },
        {
            key: "firstRunDate",
            title: "首次运行日期",
            dataIndex: "firstRunDate",
            width: 100,
            ellipsis: true,
        },
        {
            key: "openTime",
            title: "本次开机时间",
            dataIndex: "openTime",
            width: 100,
            ellipsis: true,
        },
        {
            key: "driverId",
            title: "司机ID",
            dataIndex: "driverId",
            width: 100,
            ellipsis: true,
        },
        {
            key: "certNo",
            title: "作业证号",
            dataIndex: "certNo",
            width: 100,
            ellipsis: true,
        },
        {
            key: "elevatorLogId",
            title: "养成记录ID",
            dataIndex: "elevatorLogId",
            width: 100,
            ellipsis: true,
        },
        {
            key: "createdTime",
            title: "创建时间",
            dataIndex: "createdTime",
            width: 100,
            ellipsis: true,
        },
        {
            key: "updatedTime",
            title: "更新时间",
            dataIndex: "updatedTime",
            width: 100,
            ellipsis: true,
        },
        {
            title: '操作',
            width: 120,
            dataIndex: 'actions',
            fixed: 'right',
            render: (val, record) =>{
                return [
                    <a key='view' onClick={()=>{
                        setCurrentOutsideElevatorLog(record);
                        setDetailVisible(true);
                        }}>
                        查看
                    </a>,
                    <Divider type="vertical" key="split1" />,
                    rowExtraButtons({item:record}),
                ];
            }
        },
    ];

    const reloadData = (params:object|undefined)=>{

        setSpinning(true);
        const newQueryParams = {
            ...(queryFormRef.current?.getFieldsFormatValue&&queryFormRef.current?.getFieldsFormatValue()||{}),
            ...(params||{}),
            deletedFlag: false,
        };
        setQueryParams(newQueryParams);

        OutsideElevatorLogApi.findOutsideElevatorLogPage(newQueryParams).then(pageInfo=>{
            pageInfo.list.forEach((i:any,idx:number)=>{
                i.rowNo = idx + 1 + (pageInfo.pageNum-1)*pageInfo.pageSize;
            });
            setPageData(pageInfo);
        }).finally(()=>{
            setSpinning(false);
        });
    }

    const batchDelete = async()=>{
        if(selectedRows.length<1){
            message.error("请先选择数据");
            return;
        }

        Modal.confirm({
            title: "批量删除",
            content: "确定删除所选升降机原始记录吗？",
            okText: "确定",
            cancelText: "取消",
            onOk: async () => {
                for(let i=0; i<selectedRows.length; i++){
                    const row = selectedRows[i];

                    await OutsideElevatorLogApi.deleteOutsideElevatorLog(row);
                }

                message.success("数据删除成功！");
                reloadData({});
            }
        });
    }

    //表格大小变化事件
    useEffect(()=>{

        setColumns(defaultColumns);
        reloadData({});

        const interval = setInterval(()=>{
            if(container.current?.offsetHeight!=tableHeight){
                console.log(tableHeight);
                setTableHeight(container.current?.offsetHeight||0);
            }
        }, 200);

        return ()=>{
            clearInterval(interval);
        };
    }, []);

    const deleteOutsideElevatorLog = (outsideElevatorLog:OutsideElevatorLog)=>{
        Modal.confirm({
            title: "删除升降机原始记录确认",
            content: "确定删除该升降机原始记录吗？",
            okText: "确定",
            cancelText: "取消",
            onOk: async () => {
                await OutsideElevatorLogApi.deleteOutsideElevatorLog(outsideElevatorLog);
            }
        });
    }

    const rowExtraButtons : React.FC<{
        item: OutsideElevatorLog
    }> = ({item}) => {
        return (
            <Dropdown
                key="row-extra-btns"
                overlay={
                    <Menu
                        onClick={({key})=>{
                            if(key==='delete') {
                                deleteOutsideElevatorLog(item);
                            }
                        }}
                    >
                        <Menu.Item key="delete">
                            删除
                        </Menu.Item>
                    </Menu>
                }
            >
                <a key='extraBtn'>
                    更多 <DownOutlined />
                </a>
            </Dropdown>
        );
    };

    const formFieldSpan={ xs: 24, sm: 12, md: 8, lg: 6, xl:6, xxl:6 };

    const queryFormFields = [
        <div key='qf1' style={{display:'inline-block', height:40, width:260}}>
            <ProFormText
                label="企业名称"
                name="name"
            />
        </div>,
    ];

    const getQueryFields = ()=>{
        let endIdx = queryFormExpand&&queryFormFields.length>2?queryFormFields.length:2;

        const fields = [];

        for(let i=0; i<endIdx; i++){
            fields.push(queryFormFields[i])
        }

        return fields;
    }

    return (
        <div style={{width:'100%', height:'100%', display: "flex", flexDirection: 'column'}}>
            <div style={{backgroundColor:'#ffffff', padding:"8px 16px 0px 16px", marginBottom:12}}>
                <ProForm
                    formRef={queryFormRef}
                    submitter={false}
                    layout={'horizontal'}
                    initialValues={{

                    }}
                >
                    <Space align="start" wrap>
                        { getQueryFields()}

                        <Button
                            type="primary"
                            onClick={()=>{
                                reloadData({});
                            }}
                        >
                            查询
                        </Button>

                        <Button
                            type="primary"
                            danger
                            onClick={()=>{
                                queryFormRef.current?.resetFields();
                            }}
                        >
                            重置
                        </Button>

                        {
                            queryFormFields.length>2 &&
                            <Button
                                type="link"
                                onClick={()=>{
                                    setQueryFormExpand(!queryFormExpand);
                                }}
                            >
                                {queryFormExpand?'收起':'展开'}{queryFormExpand?<UpOutlined />:<DownOutlined />}
                            </Button>
                        }
                    </Space>
                </ProForm>
            </div>

            <div style={{backgroundColor:'#ffffff', height:56, lineHeight:'56px', paddingLeft:16, paddingRight:16}}>
                <div style={{fontWeight:'bold', display:'inline-block'}}>
                    升降机原始记录列表
                </div>
                <div style={{display: 'inline-block', float: 'right'}}>
                    <Space size={16}>
                        {
                            selectedRows.length>0 &&
                            <Button type="link">
                                已选择 <strong>{selectedRows.length}</strong> 条
                            </Button>
                        }

                        <Button
                            type="primary"
                            onClick={()=>{
                                setAddFormVisible(true);
                            }}
                        >
                            新建
                        </Button>
                        <Dropdown.Button
                            overlay={
                               <Menu
                                    onClick={({key})=>{
                                        if(key==='batchDelete'){
                                            batchDelete();
                                        }
                                    }}
                                    items={[{
                                        key: 'batchDelete',
                                        label: '批量删除',
                                    }]}
                               />
                            }
                        >
                            批量操作
                        </Dropdown.Button>
                        <RedoOutlined
                            style={{fontSize:16, cursor:'pointer'}}
                            onClick={()=>{
                                reloadData({});
                            }}
                        />
                        <TableSizeSetting
                            onChange={(val)=>{
                                setTableSize(val)
                            }}
                        />
                        <TableColumnSetting
                            columns={columns}
                            onChange={(value)=>{
                                setColumns(value)
                            }}
                        />
                    </Space>
                </div>
            </div>
            <div style={{flex:1, position:'relative'}}>
                <div
                    ref={container}
                    style={{width: '100%', height:'100%', position:'absolute'}}
                >
                    <Spin spinning={spinning}>
                        <Table
                            dataSource={pageData?.list}
                            pagination={{
                                current: queryParams?.page||1,
                                pageSize: queryParams?.pageSize||10,
                                total: pageData?.total,
                                pageSizeOptions: [10, 20, 50, 100],
                                showQuickJumper: true,
                                showSizeChanger: true,
                                onChange:(page, pageSize)=>{
                                    reloadData({
                                        page: page,
                                        pageSize: pageSize,
                                    });
                                },
                                onShowSizeChange:(page, pageSize)=>{
                                    reloadData({
                                        page: page,
                                        pageSize: pageSize,
                                    });

                                }
                            }}
                            size={tableSize}
                            rowKey="id"
                            columns={columns}
                            scroll={{x: TableUtils.getTableScrollX(columns), y: getTableScrollY(tableSize, true, tableHeight), scrollToFirstRowOnChange:true}}
                            rowSelection={{
                                selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
                                defaultSelectedRowKeys: [],
                                onChange:(selectedRowKeys, selectedRows)=>{
                                    setSelectedRows(selectedRows);
                                }
                            }}
                        />
                    </Spin>
                </div>
            </div>


            {
                addFormVisible &&
                <OutsideElevatorLogAddForm
                    visible={true}
                    onSuccess={()=>{
                        setAddFormVisible(false);
                        reloadData({});
                    }}
                    onFail={()=>{
                        setAddFormVisible(false);
                    }}
                />
            }

            {
                detailVisible &&
                <OutsideElevatorLogDetail
                    outsideElevatorLog={currentOutsideElevatorLog}
                    visible={true}
                    onSuccess={()=>{
                        setDetailVisible(false);
                        reloadData({});
                    }}
                    onFail={()=>{
                        setDetailVisible(false);
                    }}
                />
            }
        </div>
    );
};

export default OutsideElevatorLogPage;